import { render, staticRenderFns } from "./BuyerPurchase.vue?vue&type=template&id=2bfb7f60&scoped=true&"
import script from "./BuyerPurchase.vue?vue&type=script&lang=js&"
export * from "./BuyerPurchase.vue?vue&type=script&lang=js&"
import style0 from "./BuyerPurchase.vue?vue&type=style&index=0&id=2bfb7f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfb7f60",
  null
  
)

export default component.exports